import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const defaults = {
  logoUrl: null,
  siteName: 'House of Sample',
  tagline: 'Focus On Quality',
  contact: { address: '', phone: '', email: '', hours: 'Mon–Sat: 9:00 AM – 6:00 PM', mapUrl: '' },
  socialLinks: [],
  typography: {
    bodyFont:    'Inter',
    headingFont: 'Playfair Display',
    baseColor:   '#1A1A1A',
    accentColor: '#B8A830',
    baseFontSize:'16',
    fontStyle:   'normal',
  },
};

const SiteSettingsContext = createContext({ settings: defaults, loading: true, refresh: () => {} });

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(defaults);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    api.get('/settings')
      .then(res => {
        const s = res.data.settings || {};
        setSettings({
          ...defaults,
          ...s,
          contact: { ...defaults.contact, ...(s.contact || {}) },
          socialLinks: Array.isArray(s.socialLinks) ? s.socialLinks : defaults.socialLinks,
          typography: { ...defaults.typography, ...(s.typography || {}) },
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refresh }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);
